/**
 * Final CTA — last call-to-action before the footer.
 *
 * Centered card with a subtle fire glow. Anchors the visitor's eye
 * after they've scrolled through features + FAQ and need one more push.
 */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { useAuthStore } from '@/stores/auth'

export function FinalCta() {
  const { t } = useTranslation('landing')
  const isAuthed = useAuthStore((s) => !!s.accessToken)
  return (
    <section className="px-6 py-20 md:py-28 border-t border-line relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(600px 280px at 50% 50%, rgba(255,69,36,0.10), transparent 60%)',
        }}
      />
      <div className="relative max-w-2xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">
          {t('final_cta.title')}
        </h2>
        <p className="mt-3 text-base text-textDim">
          {t('final_cta.subtitle')}
        </p>
        <div className="mt-8">
          {isAuthed ? (
            <Link to="/app"><Button size="lg">{t('final_cta.button')}</Button></Link>
          ) : (
            <Link to="/register"><Button size="lg">{t('final_cta.button')}</Button></Link>
          )}
        </div>
      </div>
    </section>
  )
}
